import { FormEvent } from "react"
import clsx from "classnames"
import { useNewslettersV2Context } from "../../../contexts"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { Loader2 } from "lucide-react"

interface SubscriptionFormProps {
  onSubmit: (e?: FormEvent) => void
  isLoading: boolean
  selectedCount: number
}

/**
 * Email input form with subscribe button.
 * Manages email state through NewslettersV2Context.
 */
export const SubscriptionForm = ({ onSubmit, isLoading, selectedCount }: SubscriptionFormProps) => {
  const { email, setEmail } = useNewslettersV2Context()
  const t = useTranslations("newsletters")

  return (
    <form
      onSubmit={onSubmit}
      className="relative w-full max-w-lg"
      aria-busy={isLoading ? "true" : "false"}
      aria-describedby="subscribe-help"
    >
      <label htmlFor="email" className="sr-only">
        {t("v2.input.email_label")}
      </label>
      <input
        id="email"
        type="email"
        name="email"
        autoComplete="email"
        placeholder={t("v2.input.email_placeholder")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="mb-6 h-12 w-full rounded-full border !border-black px-4 py-3 pr-32 text-base font-normal placeholder:font-normal placeholder:text-gray-500 focus:!border-black focus:ring-2 focus:ring-black focus:ring-offset-2 focus:outline-none"
      />
      <div className="absolute top-1 right-1">
        <button
          type="submit"
          disabled={selectedCount === 0 || isLoading}
          className={clsx("relative h-10 rounded-full px-4 text-sm text-white", {
            "cursor-not-allowed bg-gray-300": selectedCount === 0,
            "bg-black hover:bg-gray-800": selectedCount > 0,
            "pointer-events-none !bg-gray-600": isLoading,
          })}
        >
          <span className={isLoading ? "opacity-0" : "opacity-100"}>{t("button.subscribe")}</span>
          {isLoading && (
            <Loader2 className="absolute top-1/2 left-1/2 size-5 -translate-x-1/2 -translate-y-1/2 animate-spin" />
          )}
        </button>
      </div>
    </form>
  )
}
